import { getFallbackImageUrl } from "../image-fixtures.js";

export const getHotelAvailabilityResponseMock = () => ({ default: hotelAvailabilityResponseMock });

const hotelAvailabilityResponseMock = {
  itemsCount: 9,
  isCompleted: true,
  reqId: "81-BE-FF-32-1D-8C-41-AA-55-A8-72-BF-DF-99-BF-D0",
  hotels: [
    {
      id: 125866,
      placeId: "H125866",
      name: "Andaz 5th Avenue",
      starRating: 4,
      amenities: [
        {
          id: 107,
          name: "Free WiFi",
          categoryId: 38,
          categoryName: "Free WiFi",
          categoryTopOrder: 1,
        },
        {
          id: 52,
          name: "Valet parking",
          categoryId: 16,
          categoryName: "Parking",
          categoryTopOrder: 3,
        },
        {
          id: 160,
          name: "On-site parking",
          categoryId: 16,
          categoryName: "Parking",
          categoryTopOrder: 3,
        },
        {
          id: 161,
          name: "Private parking",
          categoryId: 16,
          categoryName: "Parking",
          categoryTopOrder: 3,
        },
        {
          id: 181,
          name: "Parking garage",
          categoryId: 16,
          categoryName: "Parking",
          categoryTopOrder: 3,
        },
        {
          id: 2,
          name: "Parking",
          categoryId: 16,
          categoryName: "Parking",
          categoryTopOrder: 3,
        },
        {
          id: 5,
          name: "Room service",
          categoryId: 32,
          categoryName: "Room service",
          categoryTopOrder: 7,
        },
        {
          id: 7,
          name: "Bar",
          categoryId: 33,
          categoryName: "Bar",
          categoryTopOrder: 10,
        },
        {
          id: 109,
          name: "Air conditioning",
          categoryId: 39,
          categoryName: "Air conditioning",
          categoryTopOrder: 11,
        },
        {
          id: 28,
          name: "Family rooms",
          categoryId: 36,
          categoryName: "Family friendly",
          categoryTopOrder: 12,
        },
        {
          id: 4,
          name: "Pets allowed",
          categoryId: 31,
          categoryName: "Pets friendly",
          categoryTopOrder: 13,
        },
        {
          id: 2131,
          name: "Meeting rooms",
          categoryId: 27,
          categoryName: "Business services",
          categoryTopOrder: 0,
        },
        {
          id: 13,
          name: "Newspapers",
          categoryId: 1,
          categoryName: "More",
          categoryTopOrder: 0,
        },
        {
          id: 16,
          name: "Non-smoking rooms",
          categoryId: 29,
          categoryName: "Eco-friendly",
          categoryTopOrder: 0,
        },
        {
          id: 369,
          name: "Laundry facilities",
          categoryId: 3,
          categoryName: "Guest services",
          categoryTopOrder: 0,
        },
        {
          id: 23,
          name: "Dry cleaning",
          categoryId: 1,
          categoryName: "More",
          categoryTopOrder: 0,
        },
        {
          id: 25,
          name: "Facilities for disabled guests",
          categoryId: 19,
          categoryName: "Accessibility",
          categoryTopOrder: 0,
        },
        {
          id: 3810,
          name: "Fishing on site",
          categoryId: 2,
          categoryName: "Things to do",
          categoryTopOrder: 0,
        },
        {
          id: 47,
          name: "Internet services",
          categoryId: 3,
          categoryName: "Guest services",
          categoryTopOrder: 0,
        },
        {
          id: 48,
          name: "Lift",
          categoryId: 29,
          categoryName: "Eco-friendly",
          categoryTopOrder: 0,
        },
        {
          id: 51,
          name: "Safety deposit box",
          categoryId: 1,
          categoryName: "More",
          categoryTopOrder: 0,
        },
        {
          id: 124,
          name: "Concierge service",
          categoryId: 1,
          categoryName: "More",
          categoryTopOrder: 0,
        },
        {
          id: 158,
          name: "Daily maid service",
          categoryId: 1,
          categoryName: "More",
          categoryTopOrder: 0,
        },
        {
          id: 108,
          name: "Non-smoking throughout",
          categoryId: 29,
          categoryName: "Eco-friendly",
          categoryTopOrder: 0,
        },
        {
          id: 64,
          name: "Soundproof rooms",
          categoryId: 29,
          categoryName: "Eco-friendly",
          categoryTopOrder: 0,
        },
        {
          id: 67,
          name: "Shoeshine",
          categoryId: 1,
          categoryName: "More",
          categoryTopOrder: 0,
        },
        {
          id: 80,
          name: "Heating",
          categoryId: 29,
          categoryName: "Eco-friendly",
          categoryTopOrder: 0,
        },
        {
          id: 91,
          name: "Luggage storage",
          categoryId: 1,
          categoryName: "More",
          categoryTopOrder: 0,
        },
        {
          id: 92,
          name: "Shops (on site)",
          categoryId: 1,
          categoryName: "More",
          categoryTopOrder: 0,
        },
        {
          id: 96,
          name: "WiFi",
          categoryId: 3,
          categoryName: "Guest services",
          categoryTopOrder: 0,
        },
        {
          id: 101,
          name: "Allergy-free room",
          categoryId: 29,
          categoryName: "Eco-friendly",
          categoryTopOrder: 0,
        },
        {
          id: 185,
          name: "Wheelchair accessible",
          categoryId: 29,
          categoryName: "Eco-friendly",
          categoryTopOrder: 0,
        },
        {
          id: 163,
          name: "WiFi available in all areas",
          categoryId: 1,
          categoryName: "More",
          categoryTopOrder: 0,
        },
      ],
      mainImage: {
        largeUrl: null,
      },
      location: {
        countryName: "United States of America",
        stateCode: "NY",
        cityName: "Long Island City",
        address: "485 5th Avenue at 41st Street, New York, New York 10017",
        latitude: 40.75253,
        longitude: -73.981316,
      },
      rating: {
        id: 23973,
        score: 5,
        reviewsCount: 2936,
        ratingUrl:
          "https://www.tripadvisor.com/Hotel_Review-g60763-d1762573-Reviews-Andaz_5th_Avenue-New_York_City_New_York.html?m=58362#REVIEWS",
      },
      rateModel: "AllInclusive",
      deal: {
        dealKey:
          "CAIQgwYiDAjgtp3EBhD8wJqsAipJDQAAekMVAADQQyXheqRBLQrXAUMwATjoB0UAAPpDSgsI4LadxAYQ6PKqWGIKOGRkMzNiNGYtNmgCggEAjQGamXlDmAEDqAHIBjiq1wdAtKcPSAJSCEQT-639FORBWMgG",
        currencyCode: "USD",
        nightlyPrice: 250.0,
        roomPrice: 174.8,
        totalRoomsPrice: 349.6,
        totalTaxes: 150.4,
        totalFees: 0,
        totalPrice: 500.0,
        totalHotelFees: 0,
        totalPriceWithHotelFees: 500.0,
        totalRoomsPriceWithHotelFees: 349.6,
        cancellationPolicy: {
          type: "Refundable",
          deadline: "2030-01-01",
        },
      },
    },
    {
      id: 125867,
      placeId: "H125867",
      name: "Hyatt Centric Wall Street New York",
      starRating: 4,
      amenities: [
        {
          id: 107,
          name: "Free WiFi",
          categoryId: 38,
          categoryName: "Free WiFi",
          categoryTopOrder: 1,
        },
        {
          id: 5,
          name: "Room service",
          categoryId: 32,
          categoryName: "Room service",
          categoryTopOrder: 7,
        },
        {
          id: 7,
          name: "Bar",
          categoryId: 33,
          categoryName: "Bar",
          categoryTopOrder: 10,
        },
        {
          id: 109,
          name: "Air conditioning",
          categoryId: 39,
          categoryName: "Air conditioning",
          categoryTopOrder: 11,
        },
        {
          id: 28,
          name: "Family rooms",
          categoryId: 36,
          categoryName: "Family friendly",
          categoryTopOrder: 12,
        },
        {
          id: 4,
          name: "Pets allowed",
          categoryId: 31,
          categoryName: "Pets friendly",
          categoryTopOrder: 13,
        },
        {
          id: 47,
          name: "Internet services",
          categoryId: 3,
          categoryName: "Guest services",
          categoryTopOrder: 0,
        },
        {
          id: 48,
          name: "Lift",
          categoryId: 29,
          categoryName: "Eco-friendly",
          categoryTopOrder: 0,
        },
        {
          id: 49,
          name: "Express check-in/check-out",
          categoryId: 1,
          categoryName: "More",
          categoryTopOrder: 0,
        },
        {
          id: 53,
          name: "Currency exchange",
          categoryId: 1,
          categoryName: "More",
          categoryTopOrder: 0,
        },
        {
          id: 67,
          name: "Shoeshine",
          categoryId: 1,
          categoryName: "More",
          categoryTopOrder: 0,
        },
        {
          id: 80,
          name: "Heating",
          categoryId: 29,
          categoryName: "Eco-friendly",
          categoryTopOrder: 0,
        },
        {
          id: 91,
          name: "Luggage storage",
          categoryId: 1,
          categoryName: "More",
          categoryTopOrder: 0,
        },
        {
          id: 96,
          name: "WiFi",
          categoryId: 3,
          categoryName: "Guest services",
          categoryTopOrder: 0,
        },
        {
          id: 13,
          name: "Newspapers",
          categoryId: 1,
          categoryName: "More",
          categoryTopOrder: 0,
        },
        {
          id: 16,
          name: "Non-smoking rooms",
          categoryId: 29,
          categoryName: "Eco-friendly",
          categoryTopOrder: 0,
        },
        {
          id: 369,
          name: "Laundry facilities",
          categoryId: 3,
          categoryName: "Guest services",
          categoryTopOrder: 0,
        },
        {
          id: 23,
          name: "Dry cleaning",
          categoryId: 1,
          categoryName: "More",
          categoryTopOrder: 0,
        },
        {
          id: 25,
          name: "Facilities for disabled guests",
          categoryId: 19,
          categoryName: "Accessibility",
          categoryTopOrder: 0,
        },
        {
          id: 3810,
          name: "Fishing on site",
          categoryId: 2,
          categoryName: "Things to do",
          categoryTopOrder: 0,
        },
        {
          id: 124,
          name: "Concierge service",
          categoryId: 1,
          categoryName: "More",
          categoryTopOrder: 0,
        },
        {
          id: 158,
          name: "Daily maid service",
          categoryId: 1,
          categoryName: "More",
          categoryTopOrder: 0,
        },
        {
          id: 163,
          name: "WiFi available in all areas",
          categoryId: 1,
          categoryName: "More",
          categoryTopOrder: 0,
        },
        {
          id: 185,
          name: "Wheelchair accessible",
          categoryId: 29,
          categoryName: "Eco-friendly",
          categoryTopOrder: 0,
        },
        {
          id: 186,
          name: "Toilet with grab rails",
          categoryId: 29,
          categoryName: "Eco-friendly",
          categoryTopOrder: 0,
        },
        {
          id: 2131,
          name: "Meeting rooms",
          categoryId: 27,
          categoryName: "Business services",
          categoryTopOrder: 0,
        },
        {
          id: 108,
          name: "Non-smoking throughout",
          categoryId: 29,
          categoryName: "Eco-friendly",
          categoryTopOrder: 0,
        },
      ],
      mainImage: {
        largeUrl: getFallbackImageUrl(),
      },
      location: {
        countryName: "United States of America",
        stateCode: "NY",
        cityName: "Jersey City",
        address: "75 Wall Street, Entrance on Water Street, New York City, New York 10005",
        latitude: 40.705177,
        longitude: -74.00768,
      },
      rating: {
        id: 23974,
        score: 4.5,
        reviewsCount: 3459,
        ratingUrl:
          "https://www.tripadvisor.com/Hotel_Review-g60763-d1485961-Reviews-Andaz_Wall_Street-New_York_City_New_York.html?m=58362#REVIEWS",
      },
      rateModel: "AllInclusive",
      deal: {
        dealKey:
          "CAIQgwYiDAjgtp3EBhDw55-sAipUDQAAn0MVAIAERCUzs6FCLQAA4EAwATjoB0UAAB9ESgsI4LadxAYQsI2rWGIKMzhlNWUxOTYtYmgCfaRwZUKCAQCNAQAAn0OVASlcB0GYAQSoAcgGOKvXB0C0pw9IAlIIElrE4kEji9NYyAY",
        currencyCode: "USD",
        nightlyPrice: 346.68,
        roomPrice: 274.08,
        totalRoomsPrice: 548.15,
        totalTaxes: 96.31,
        totalFees: 0,
        totalPrice: 636.0,
        totalHotelFees: 57.36,
        totalPriceWithHotelFees: 693.36,
        totalRoomsPriceWithHotelFees: 605.51,
        cancellationPolicy: {
          type: "NonRefundable",
          deadline: null,
        },
      },
    },
    {
      id: 125868,
      placeId: "H125868",
      name: "Beacon",
      starRating: 3,
      amenities: [
        {
          id: 107,
          name: "Free WiFi",
          categoryId: 38,
          categoryName: "Free WiFi",
          categoryTopOrder: 1,
        },
        {
          id: 2,
          name: "Parking",
          categoryId: 16,
          categoryName: "Parking",
          categoryTopOrder: 3,
        },
        {
          id: 7,
          name: "Bar",
          categoryId: 33,
          categoryName: "Bar",
          categoryTopOrder: 10,
        },
        {
          id: 109,
          name: "Air conditioning",
          categoryId: 39,
          categoryName: "Air conditioning",
          categoryTopOrder: 11,
        },
        {
          id: 28,
          name: "Family rooms",
          categoryId: 36,
          categoryName: "Family friendly",
          categoryTopOrder: 12,
        },
        {
          id: 47,
          name: "Internet services",
          categoryId: 3,
          categoryName: "Guest services",
          categoryTopOrder: 0,
        },
        {
          id: 48,
          name: "Lift",
          categoryId: 29,
          categoryName: "Eco-friendly",
          categoryTopOrder: 0,
        },
        {
          id: 51,
          name: "Safety deposit box",
          categoryId: 1,
          categoryName: "More",
          categoryTopOrder: 0,
        },
        {
          id: 64,
          name: "Soundproof rooms",
          categoryId: 29,
          categoryName: "Eco-friendly",
          categoryTopOrder: 0,
        },
        {
          id: 80,
          name: "Heating",
          categoryId: 29,
          categoryName: "Eco-friendly",
          categoryTopOrder: 0,
        },
        {
          id: 91,
          name: "Luggage storage",
          categoryId: 1,
          categoryName: "More",
          categoryTopOrder: 0,
        },
        {
          id: 96,
          name: "WiFi",
          categoryId: 3,
          categoryName: "Guest services",
          categoryTopOrder: 0,
        },
        {
          id: 124,
          name: "Concierge service",
          categoryId: 1,
          categoryName: "More",
          categoryTopOrder: 0,
        },
        {
          id: 158,
          name: "Daily maid service",
          categoryId: 1,
          categoryName: "More",
          categoryTopOrder: 0,
        },
        {
          id: 163,
          name: "WiFi available in all areas",
          categoryId: 1,
          categoryName: "More",
          categoryTopOrder: 0,
        },
        {
          id: 13,
          name: "Newspapers",
          categoryId: 1,
          categoryName: "More",
          categoryTopOrder: 0,
        },
        {
          id: 16,
          name: "Non-smoking rooms",
          categoryId: 29,
          categoryName: "Eco-friendly",
          categoryTopOrder: 0,
        },
        {
          id: 369,
          name: "Laundry facilities",
          categoryId: 3,
          categoryName: "Guest services",
          categoryTopOrder: 0,
        },
        {
          id: 23,
          name: "Dry cleaning",
          categoryId: 1,
          categoryName: "More",
          categoryTopOrder: 0,
        },
        {
          id: 25,
          name: "Facilities for disabled guests",
          categoryId: 19,
          categoryName: "Accessibility",
          categoryTopOrder: 0,
        },
        {
          id: 3810,
          name: "Fishing on site",
          categoryId: 2,
          categoryName: "Things to do",
          categoryTopOrder: 0,
        },
        {
          id: 2131,
          name: "Meeting rooms",
          categoryId: 27,
          categoryName: "Business services",
          categoryTopOrder: 0,
        },
        {
          id: 108,
          name: "Non-smoking throughout",
          categoryId: 29,
          categoryName: "Eco-friendly",
          categoryTopOrder: 0,
        },
      ],
      mainImage: null,
      location: {
        countryName: "United States of America",
        stateCode: "NY",
        cityName: "Long Island City",
        address: "2130 Broadway at 75th Street, New York, New York 10023",
        latitude: 40.780575,
        longitude: -73.98123,
      },
      rating: {
        id: 23975,
        score: 4.5,
        reviewsCount: 5046,
        ratingUrl:
          "https://www.tripadvisor.com/Hotel_Review-g60763-d93338-Reviews-Hotel_Beacon-New_York_City_New_York.html?m=58362#REVIEWS",
      },
      rateModel: "AllInclusive",
      deal: {
        dealKey:
          "CAIQgwYiDAjgtp3EBhD8-aCsAipGDQAAq0MVAIAORCUfBa1CLQAAMEEwATjoB0UAACtESgsI4LadxAYQuJurWGIKOTJkYTYzOGUtMGgCggEAjQEAAKtDqAHIBjis1wdAtKcPSAJSCHZXYYrgVAOsWMgG",
        currencyCode: "USD",
        nightlyPrice: 342.0,
        roomPrice: 293.25,
        totalRoomsPrice: 586.49,
        totalTaxes: 97.51,
        totalFees: 0,
        totalPrice: 684.0,
        totalHotelFees: 0,
        totalPriceWithHotelFees: 684.0,
        totalRoomsPriceWithHotelFees: 586.49,
        cancellationPolicy: {
          type: "NonRefundable",
          deadline: null,
        },
      },
    },
    {
      id: 125869,
      placeId: "H125869",
      name: "The Renwick Hotel",
      starRating: 3,
      amenities: [
        {
          id: 107,
          name: "Free WiFi",
          categoryId: 38,
          categoryName: "Free WiFi",
          categoryTopOrder: 1,
        },
        {
          id: 52,
          name: "Valet parking",
          categoryId: 16,
          categoryName: "Parking",
          categoryTopOrder: 3,
        },
        {
          id: 2,
          name: "Parking",
          categoryId: 16,
          categoryName: "Parking",
          categoryTopOrder: 3,
        },
        {
          id: 109,
          name: "Air conditioning",
          categoryId: 39,
          categoryName: "Air conditioning",
          categoryTopOrder: 11,
        },
        {
          id: 28,
          name: "Family rooms",
          categoryId: 36,
          categoryName: "Family friendly",
          categoryTopOrder: 12,
        },
        {
          id: 47,
          name: "Internet services",
          categoryId: 3,
          categoryName: "Guest services",
          categoryTopOrder: 0,
        },
        {
          id: 48,
          name: "Lift",
          categoryId: 29,
          categoryName: "Eco-friendly",
          categoryTopOrder: 0,
        },
        {
          id: 49,
          name: "Express check-in/check-out",
          categoryId: 1,
          categoryName: "More",
          categoryTopOrder: 0,
        },
        {
          id: 51,
          name: "Safety deposit box",
          categoryId: 1,
          categoryName: "More",
          categoryTopOrder: 0,
        },
        {
          id: 80,
          name: "Heating",
          categoryId: 29,
          categoryName: "Eco-friendly",
          categoryTopOrder: 0,
        },
        {
          id: 91,
          name: "Luggage storage",
          categoryId: 1,
          categoryName: "More",
          categoryTopOrder: 0,
        },
        {
          id: 96,
          name: "WiFi",
          categoryId: 3,
          categoryName: "Guest services",
          categoryTopOrder: 0,
        },
        {
          id: 124,
          name: "Concierge service",
          categoryId: 1,
          categoryName: "More",
          categoryTopOrder: 0,
        },
        {
          id: 134,
          name: "Trouser press",
          categoryId: 1,
          categoryName: "More",
          categoryTopOrder: 0,
        },
        {
          id: 158,
          name: "Daily maid service",
          categoryId: 1,
          categoryName: "More",
          categoryTopOrder: 0,
        },
        {
          id: 163,
          name: "WiFi available in all areas",
          categoryId: 1,
          categoryName: "More",
          categoryTopOrder: 0,
        },
        {
          id: 108,
          name: "Non-smoking throughout",
          categoryId: 29,
          categoryName: "Eco-friendly",
          categoryTopOrder: 0,
        },
        {
          id: 3810,
          name: "Fishing on site",
          categoryId: 2,
          categoryName: "Things to do",
          categoryTopOrder: 0,
        },
        {
          id: 13,
          name: "Newspapers",
          categoryId: 1,
          categoryName: "More",
          categoryTopOrder: 0,
        },
        {
          id: 16,
          name: "Non-smoking rooms",
          categoryId: 29,
          categoryName: "Eco-friendly",
          categoryTopOrder: 0,
        },
        {
          id: 369,
          name: "Laundry facilities",
          categoryId: 3,
          categoryName: "Guest services",
          categoryTopOrder: 0,
        },
        {
          id: 23,
          name: "Dry cleaning",
          categoryId: 1,
          categoryName: "More",
          categoryTopOrder: 0,
        },
        {
          id: 25,
          name: "Facilities for disabled guests",
          categoryId: 19,
          categoryName: "Accessibility",
          categoryTopOrder: 0,
        },
      ],
      mainImage: {
        largeUrl: getFallbackImageUrl(),
      },
      location: {
        countryName: "United States of America",
        stateCode: "NY",
        cityName: "Long Island City",
        address: "118 East 40th Street, New York, New York 10016",
        latitude: 40.75028,
        longitude: -73.977516,
      },
      rating: {
        id: 23976,
        score: 4.5,
        reviewsCount: 1813,
        ratingUrl:
          "https://www.tripadvisor.com/Hotel_Review-g60763-d8680787-Reviews-The_Renwick_Hotel_New_York_City_Curio_Collection_by_Hilton-New_York_City_New_York.html?m=58362#REVIEWS",
      },
      rateModel: "AllInclusive",
      deal: {
        dealKey:
          "CAIQgwYiDAjgtp3EBhDI_6GsAipUDQAAa0MVAADEQyU9Cm5CLQAA4EAwATjoB0UAAOtDSgsI4LadxAYQ-KerWGIKYzE4MzVlZDItZWgCfdejoEKCAQCNATMza0OVAaRwPUGYAQGoAcgGOK3XB0C0pw9IAlIIYGPAaT3tebZYyAY",
        currencyCode: "USD",
        nightlyPrice: 275.16,
        roomPrice: 201.75,
        totalRoomsPrice: 403.49,
        totalTaxes: 78.35,
        totalFees: 0,
        totalPrice: 470.0,
        totalHotelFees: 80.32,
        totalPriceWithHotelFees: 550.32,
        totalRoomsPriceWithHotelFees: 483.81,
        cancellationPolicy: {
          type: "NonRefundable",
          deadline: null,
        },
      },
    },
    {
      id: 125870,
      placeId: "H125870",
      name: "The Beekman Tower, Trademark Collection by Wyndham",
      starRating: 3,
      amenities: [
        {
          id: 2135,
          name: "Sauna",
          categoryId: 37,
          categoryName: "Spa",
          categoryTopOrder: 6,
        },
        {
          id: 109,
          name: "Air conditioning",
          categoryId: 39,
          categoryName: "Air conditioning",
          categoryTopOrder: 11,
        },
      ],
      mainImage: {
        largeUrl: getFallbackImageUrl(),
      },
      location: {
        countryName: "United States of America",
        stateCode: "NY",
        cityName: "Long Island City",
        address: "3 Mitchell Place, New York, New York 10017",
        latitude: 40.753292,
        longitude: -73.96624,
      },
      rating: {
        id: 23977,
        score: 4,
        reviewsCount: 45,
        ratingUrl:
          "https://www.tripadvisor.com/Hotel_Review-g60763-d11775683-Reviews-Beekman_Tower-New_York_City_New_York.html?m=58362#REVIEWS",
      },
      rateModel: "AllInclusive",
      deal: {
        dealKey:
          "CAIQgwYiDAjgtp3EBhCIiaOsAipUDQAAb0MVAADHQyXXo3FCLQAAAEEwATjoB0UAAO9DSgsI4LadxAYQgLarWGIKODBjNzcyNTQtM2gCfQAAskKCAQCNAc3MbkOVAXsUUkGYAQKoAcgGOK7XB0C0pw9IAlIIvbz8dW1fVf9YyAY",
        currencyCode: "USD",
        nightlyPrice: 283.5,
        roomPrice: 204.8,
        totalRoomsPrice: 409.59,
        totalTaxes: 81.54,
        totalFees: 0,
        totalPrice: 478.0,
        totalHotelFees: 89.0,
        totalPriceWithHotelFees: 567.0,
        totalRoomsPriceWithHotelFees: 498.59,
        cancellationPolicy: {
          type: "NonRefundable",
          deadline: null,
        },
      },
    },
    {
      id: 125871,
      placeId: "H125871",
      name: "The Belvedere Hotel",
      starRating: 0,
      amenities: [
        {
          id: 109,
          name: "Air conditioning",
          categoryId: 39,
          categoryName: "Air conditioning",
          categoryTopOrder: 11,
        },
      ],
      mainImage: {
        largeUrl: null,
      },
      location: {
        countryName: "United States of America",
        stateCode: "NY",
        cityName: "Long Island City",
        address: "319 West 48th Street, New York, New York 10036",
        latitude: 40.761627,
        longitude: -73.9881,
      },
      rating: {
        id: 23978,
        score: 4,
        reviewsCount: 6172,
        ratingUrl:
          "https://www.tripadvisor.com/Hotel_Review-g60763-d93569-Reviews-Belvedere_Hotel-New_York_City_New_York.html?m=58362#REVIEWS",
      },
      rateModel: "AllInclusive",
      deal: {
        dealKey:
          "CAIQgwYiDAjgtp3EBhDgiqSsAipJDQAAXkMVAAC5QyXXo15CLQAAMEEwATjoB0UAAN5DSgsI4LadxAYQ0MWrWGIKMDliZTRjYzgtZmgCggEAjQEAAF5DmAEDqAHIBjiv1wdAtKcPSAJSCEJdYB1CmpJcWMgG",
        currencyCode: "USD",
        nightlyPrice: 222.0,
        roomPrice: 188.67,
        totalRoomsPrice: 377.34,
        totalTaxes: 66.66,
        totalFees: 0,
        totalPrice: 444.0,
        totalHotelFees: 0,
        totalPriceWithHotelFees: 444.0,
        totalRoomsPriceWithHotelFees: 377.34,
        cancellationPolicy: {
          type: "NonRefundable",
          deadline: null,
        },
      },
    },
    {
      id: 125872,
      placeId: "H125872",
      name: "The Bentley Hotel New York",
      starRating: 4,
      amenities: [
        {
          id: 7,
          name: "Bar",
          categoryId: 33,
          categoryName: "Bar",
          categoryTopOrder: 10,
        },
        {
          id: 109,
          name: "Air conditioning",
          categoryId: 39,
          categoryName: "Air conditioning",
          categoryTopOrder: 11,
        },
        {
          id: 28,
          name: "Family rooms",
          categoryId: 36,
          categoryName: "Family friendly",
          categoryTopOrder: 12,
        },
        {
          id: 4,
          name: "Pets allowed",
          categoryId: 31,
          categoryName: "Pets friendly",
          categoryTopOrder: 13,
        },
        {
          id: 2131,
          name: "Meeting rooms",
          categoryId: 27,
          categoryName: "Business services",
          categoryTopOrder: 0,
        },
        {
          id: 158,
          name: "Daily maid service",
          categoryId: 1,
          categoryName: "More",
          categoryTopOrder: 0,
        },
        {
          id: 163,
          name: "WiFi available in all areas",
          categoryId: 1,
          categoryName: "More",
          categoryTopOrder: 0,
        },
        {
          id: 164,
          name: "Paid WiFi",
          categoryId: 1,
          categoryName: "More",
          categoryTopOrder: 0,
        },
        {
          id: 186,
          name: "Toilet with grab rails",
          categoryId: 29,
          categoryName: "Eco-friendly",
          categoryTopOrder: 0,
        },
        {
          id: 47,
          name: "Internet services",
          categoryId: 3,
          categoryName: "Guest services",
          categoryTopOrder: 0,
        },
        {
          id: 48,
          name: "Lift",
          categoryId: 29,
          categoryName: "Eco-friendly",
          categoryTopOrder: 0,
        },
        {
          id: 51,
          name: "Safety deposit box",
          categoryId: 1,
          categoryName: "More",
          categoryTopOrder: 0,
        },
        {
          id: 80,
          name: "Heating",
          categoryId: 29,
          categoryName: "Eco-friendly",
          categoryTopOrder: 0,
        },
        {
          id: 91,
          name: "Luggage storage",
          categoryId: 1,
          categoryName: "More",
          categoryTopOrder: 0,
        },
        {
          id: 96,
          name: "WiFi",
          categoryId: 3,
          categoryName: "Guest services",
          categoryTopOrder: 0,
        },
        {
          id: 108,
          name: "Non-smoking throughout",
          categoryId: 29,
          categoryName: "Eco-friendly",
          categoryTopOrder: 0,
        },
        {
          id: 13,
          name: "Newspapers",
          categoryId: 1,
          categoryName: "More",
          categoryTopOrder: 0,
        },
        {
          id: 16,
          name: "Non-smoking rooms",
          categoryId: 29,
          categoryName: "Eco-friendly",
          categoryTopOrder: 0,
        },
        {
          id: 369,
          name: "Laundry facilities",
          categoryId: 3,
          categoryName: "Guest services",
          categoryTopOrder: 0,
        },
        {
          id: 23,
          name: "Dry cleaning",
          categoryId: 1,
          categoryName: "More",
          categoryTopOrder: 0,
        },
        {
          id: 25,
          name: "Facilities for disabled guests",
          categoryId: 19,
          categoryName: "Accessibility",
          categoryTopOrder: 0,
        },
        {
          id: 3810,
          name: "Fishing on site",
          categoryId: 2,
          categoryName: "Things to do",
          categoryTopOrder: 0,
        },
      ],
      mainImage: {
        largeUrl: getFallbackImageUrl(),
      },
      location: {
        countryName: "United States of America",
        stateCode: "NY",
        cityName: "Long Island City",
        address: "500 East 62nd Street, New York, New York 10065",
        latitude: 40.7603,
        longitude: -73.958115,
      },
      rating: {
        id: 23979,
        score: 4,
        reviewsCount: 5028,
        ratingUrl:
          "https://www.tripadvisor.com/Hotel_Review-g60763-d99302-Reviews-The_Bentley_Hotel-New_York_City_New_York.html?m=58362#REVIEWS",
      },
      rateModel: "AllInclusive",
      deal: {
        dealKey:
          "CAIQgwYiDAjgtp3EBhCAjqWsAipUDQAAUUMVAACuQyXsUVNCLQAA4EAwATjoB0UAANFDSgsI4LadxAYQ9NKrWGIKNWM1MzNiN2YtM2gCfbgeN0KCAQCNAc3MUEOVAexR2ECYAQSoAcgGOLDXB0C0pw9IAlIICIfvbEhPJnRYyAY",
        currencyCode: "USD",
        nightlyPrice: 231.89,
        roomPrice: 179.09,
        totalRoomsPrice: 358.17,
        totalTaxes: 66.59,
        totalFees: 0,
        totalPrice: 418.0,
        totalHotelFees: 45.78,
        totalPriceWithHotelFees: 463.78,
        totalRoomsPriceWithHotelFees: 403.95,
        cancellationPolicy: {
          type: "NonRefundable",
          deadline: null,
        },
      },
    },
    {
      id: 125873,
      placeId: "H125873",
      name: "The Benjamin – Royal Sonesta Hotel",
      starRating: 4,
      amenities: [
        {
          id: 107,
          name: "Free WiFi",
          categoryId: 38,
          categoryName: "Free WiFi",
          categoryTopOrder: 1,
        },
        {
          id: 52,
          name: "Valet parking",
          categoryId: 16,
          categoryName: "Parking",
          categoryTopOrder: 3,
        },
        {
          id: 2,
          name: "Parking",
          categoryId: 16,
          categoryName: "Parking",
          categoryTopOrder: 3,
        },
        {
          id: 160,
          name: "On-site parking",
          categoryId: 16,
          categoryName: "Parking",
          categoryTopOrder: 3,
        },
        {
          id: 161,
          name: "Private parking",
          categoryId: 16,
          categoryName: "Parking",
          categoryTopOrder: 3,
        },
        {
          id: 1073744398,
          name: "Health or beauty spa nearby",
          categoryId: 37,
          categoryName: "Spa",
          categoryTopOrder: 6,
        },
        {
          id: 5,
          name: "Room service",
          categoryId: 32,
          categoryName: "Room service",
          categoryTopOrder: 7,
        },
        {
          id: 7,
          name: "Bar",
          categoryId: 33,
          categoryName: "Bar",
          categoryTopOrder: 10,
        },
        {
          id: 109,
          name: "Air conditioning",
          categoryId: 39,
          categoryName: "Air conditioning",
          categoryTopOrder: 11,
        },
        {
          id: 28,
          name: "Family rooms",
          categoryId: 36,
          categoryName: "Family friendly",
          categoryTopOrder: 12,
        },
        {
          id: 4,
          name: "Pets allowed",
          categoryId: 31,
          categoryName: "Pets friendly",
          categoryTopOrder: 13,
        },
        {
          id: 3810,
          name: "Fishing on site",
          categoryId: 2,
          categoryName: "Things to do",
          categoryTopOrder: 0,
        },
        {
          id: 47,
          name: "Internet services",
          categoryId: 3,
          categoryName: "Guest services",
          categoryTopOrder: 0,
        },
        {
          id: 48,
          name: "Lift",
          categoryId: 29,
          categoryName: "Eco-friendly",
          categoryTopOrder: 0,
        },
        {
          id: 49,
          name: "Express check-in/check-out",
          categoryId: 1,
          categoryName: "More",
          categoryTopOrder: 0,
        },
        {
          id: 51,
          name: "Safety deposit box",
          categoryId: 1,
          categoryName: "More",
          categoryTopOrder: 0,
        },
        {
          id: 13,
          name: "Newspapers",
          categoryId: 1,
          categoryName: "More",
          categoryTopOrder: 0,
        },
        {
          id: 16,
          name: "Non-smoking rooms",
          categoryId: 29,
          categoryName: "Eco-friendly",
          categoryTopOrder: 0,
        },
        {
          id: 369,
          name: "Laundry facilities",
          categoryId: 3,
          categoryName: "Guest services",
          categoryTopOrder: 0,
        },
        {
          id: 23,
          name: "Dry cleaning",
          categoryId: 1,
          categoryName: "More",
          categoryTopOrder: 0,
        },
        {
          id: 25,
          name: "Facilities for disabled guests",
          categoryId: 19,
          categoryName: "Accessibility",
          categoryTopOrder: 0,
        },
        {
          id: 117,
          name: "Snack bar",
          categoryId: 1,
          categoryName: "More",
          categoryTopOrder: 0,
        },
        {
          id: 124,
          name: "Concierge service",
          categoryId: 1,
          categoryName: "More",
          categoryTopOrder: 0,
        },
        {
          id: 158,
          name: "Daily maid service",
          categoryId: 1,
          categoryName: "More",
          categoryTopOrder: 0,
        },
        {
          id: 2131,
          name: "Meeting rooms",
          categoryId: 27,
          categoryName: "Business services",
          categoryTopOrder: 0,
        },
        {
          id: 108,
          name: "Non-smoking throughout",
          categoryId: 29,
          categoryName: "Eco-friendly",
          categoryTopOrder: 0,
        },
        {
          id: 67,
          name: "Shoeshine",
          categoryId: 1,
          categoryName: "More",
          categoryTopOrder: 0,
        },
        {
          id: 78,
          name: "Tour desk",
          categoryId: 1,
          categoryName: "More",
          categoryTopOrder: 0,
        },
        {
          id: 80,
          name: "Heating",
          categoryId: 29,
          categoryName: "Eco-friendly",
          categoryTopOrder: 0,
        },
        {
          id: 89,
          name: "Ticket service",
          categoryId: 1,
          categoryName: "More",
          categoryTopOrder: 0,
        },
        {
          id: 91,
          name: "Luggage storage",
          categoryId: 1,
          categoryName: "More",
          categoryTopOrder: 0,
        },
        {
          id: 96,
          name: "WiFi",
          categoryId: 3,
          categoryName: "Guest services",
          categoryTopOrder: 0,
        },
        {
          id: 101,
          name: "Allergy-free room",
          categoryId: 29,
          categoryName: "Eco-friendly",
          categoryTopOrder: 0,
        },
        {
          id: 163,
          name: "WiFi available in all areas",
          categoryId: 1,
          categoryName: "More",
          categoryTopOrder: 0,
        },
      ],
      mainImage: {
        largeUrl: getFallbackImageUrl(),
      },
      location: {
        countryName: "United States of America",
        stateCode: "NY",
        cityName: "Long Island City",
        address: "125 East 50th Street (at Lexington Avenue), New York City, New York 10022",
        latitude: 40.756508,
        longitude: -73.97203,
      },
      rating: {
        id: 23980,
        score: 4.5,
        reviewsCount: 3324,
        ratingUrl:
          "https://www.tripadvisor.com/Hotel_Review-g60763-d217626-Reviews-The_Benjamin-New_York_City_New_York.html?m=58362#REVIEWS",
      },
      rateModel: "AllInclusive",
      deal: {
        dealKey:
          "CAIQgwYiDAjgtp3EBhCsjaasAipGDQAAfUMVAADTQyXhelBCLQAAyUIwATjoB0UAAP1DSgsI4LadxAYQtN-rWGIKNDQyMWZkN2YtYWgCggEAjQEzM31DqAHIBjix1wdAtKcPSAJSCOiHprfNpVMgWMgG",
        currencyCode: "USD",
        nightlyPrice: 253.0,
        roomPrice: 176.69,
        totalRoomsPrice: 353.38,
        totalTaxes: 152.62,
        totalFees: 0,
        totalPrice: 506.0,
        totalHotelFees: 0,
        totalPriceWithHotelFees: 506.0,
        totalRoomsPriceWithHotelFees: 353.38,
        cancellationPolicy: {
          type: "NonRefundable",
          deadline: null,
        },
      },
    },
    {
      id: 125875,
      placeId: "H125875",
      name: "Best Western Plus Hospitality House",
      starRating: 3.5,
      amenities: [
        {
          id: 107,
          name: "Free WiFi",
          categoryId: 38,
          categoryName: "Free WiFi",
          categoryTopOrder: 1,
        },
        {
          id: 179,
          name: "Secured parking",
          categoryId: 16,
          categoryName: "Parking",
          categoryTopOrder: 3,
        },
        {
          id: 181,
          name: "Parking garage",
          categoryId: 16,
          categoryName: "Parking",
          categoryTopOrder: 3,
        },
        {
          id: 2,
          name: "Parking",
          categoryId: 16,
          categoryName: "Parking",
          categoryTopOrder: 3,
        },
        {
          id: 109,
          name: "Air conditioning",
          categoryId: 39,
          categoryName: "Air conditioning",
          categoryTopOrder: 11,
        },
        {
          id: 175,
          name: "Children television networks",
          categoryId: 36,
          categoryName: "Family friendly",
          categoryTopOrder: 12,
        },
        {
          id: 21,
          name: "Babysitting/child services",
          categoryId: 36,
          categoryName: "Family friendly",
          categoryTopOrder: 12,
        },
        {
          id: 28,
          name: "Family rooms",
          categoryId: 36,
          categoryName: "Family friendly",
          categoryTopOrder: 12,
        },
        {
          id: 47,
          name: "Internet services",
          categoryId: 3,
          categoryName: "Guest services",
          categoryTopOrder: 0,
        },
        {
          id: 48,
          name: "Lift",
          categoryId: 29,
          categoryName: "Eco-friendly",
          categoryTopOrder: 0,
        },
        {
          id: 49,
          name: "Express check-in/check-out",
          categoryId: 1,
          categoryName: "More",
          categoryTopOrder: 0,
        },
        {
          id: 51,
          name: "Safety deposit box",
          categoryId: 1,
          categoryName: "More",
          categoryTopOrder: 0,
        },
        {
          id: 57,
          name: "Billiards",
          categoryId: 2,
          categoryName: "Things to do",
          categoryTopOrder: 0,
        },
        {
          id: 75,
          name: "Car hire",
          categoryId: 22,
          categoryName: "Transportation",
          categoryTopOrder: 0,
        },
        {
          id: 76,
          name: "Cycling",
          categoryId: 2,
          categoryName: "Things to do",
          categoryTopOrder: 0,
        },
        {
          id: 77,
          name: "Bowling",
          categoryId: 2,
          categoryName: "Things to do",
          categoryTopOrder: 0,
        },
        {
          id: 80,
          name: "Heating",
          categoryId: 29,
          categoryName: "Eco-friendly",
          categoryTopOrder: 0,
        },
        {
          id: 86,
          name: "Horse riding",
          categoryId: 2,
          categoryName: "Things to do",
          categoryTopOrder: 0,
        },
        {
          id: 87,
          name: "Squash",
          categoryId: 2,
          categoryName: "Things to do",
          categoryTopOrder: 0,
        },
        {
          id: 89,
          name: "Ticket service",
          categoryId: 1,
          categoryName: "More",
          categoryTopOrder: 0,
        },
        {
          id: 91,
          name: "Luggage storage",
          categoryId: 1,
          categoryName: "More",
          categoryTopOrder: 0,
        },
        {
          id: 96,
          name: "WiFi",
          categoryId: 3,
          categoryName: "Guest services",
          categoryTopOrder: 0,
        },
        {
          id: 369,
          name: "Laundry facilities",
          categoryId: 3,
          categoryName: "Guest services",
          categoryTopOrder: 0,
        },
        {
          id: 23,
          name: "Dry cleaning",
          categoryId: 1,
          categoryName: "More",
          categoryTopOrder: 0,
        },
        {
          id: 25,
          name: "Facilities for disabled guests",
          categoryId: 19,
          categoryName: "Accessibility",
          categoryTopOrder: 0,
        },
        {
          id: 3810,
          name: "Fishing on site",
          categoryId: 2,
          categoryName: "Things to do",
          categoryTopOrder: 0,
        },
        {
          id: 13,
          name: "Newspapers",
          categoryId: 1,
          categoryName: "More",
          categoryTopOrder: 0,
        },
        {
          id: 15,
          name: "Terrace",
          categoryId: 1,
          categoryName: "More",
          categoryTopOrder: 0,
        },
        {
          id: 16,
          name: "Non-smoking rooms",
          categoryId: 29,
          categoryName: "Eco-friendly",
          categoryTopOrder: 0,
        },
        {
          id: 3810,
          name: "Fishing on site",
          categoryId: 2,
          categoryName: "Things to do",
          categoryTopOrder: 0,
        },
        {
          id: 124,
          name: "Concierge service",
          categoryId: 1,
          categoryName: "More",
          categoryTopOrder: 0,
        },
        {
          id: 158,
          name: "Daily maid service",
          categoryId: 1,
          categoryName: "More",
          categoryTopOrder: 0,
        },
        {
          id: 159,
          name: "Grocery deliveries",
          categoryId: 1,
          categoryName: "More",
          categoryTopOrder: 0,
        },
        {
          id: 108,
          name: "Non-smoking throughout",
          categoryId: 29,
          categoryName: "Eco-friendly",
          categoryTopOrder: 0,
        },
      ],
      mainImage: {
        largeUrl: getFallbackImageUrl(),
      },
      location: {
        countryName: "United States of America",
        stateCode: "NY",
        cityName: "Long Island City",
        address: "145 East 49th Street, New York City, New York 10017-1210",
        latitude: 40.75569,
        longitude: -73.972176,
      },
      rating: {
        id: 23982,
        score: 4.5,
        reviewsCount: 1346,
        ratingUrl:
          "https://www.tripadvisor.com/Hotel_Review-g60763-d80087-Reviews-Best_Western_Plus_Hospitality_House-New_York_City_New_York.html?m=58362#REVIEWS",
      },
      rateModel: "AllInclusive",
      deal: {
        dealKey:
          "CAIQgwYiDAjgtp3EBhDckKisAipJDQAASEMVAACnQyXD9UVCLQAAcEEwATjoB0UAAMhDSgsI4LadxAYQqPyrWGIKNGU5NWEyYTctYmgCggEAjQFmZkhDmAECqAHIBjiz1wdAtKcPSAJSCFd66qF-PpXNWMgG",
        currencyCode: "USD",
        nightlyPrice: 200.0,
        roomPrice: 167.76,
        totalRoomsPrice: 335.51,
        totalTaxes: 64.49,
        totalFees: 0,
        totalPrice: 400.0,
        totalHotelFees: 0,
        totalPriceWithHotelFees: 400.0,
        totalRoomsPriceWithHotelFees: 335.51,
        cancellationPolicy: {
          type: "NonRefundable",
          deadline: null,
        },
      },
    },
  ],
};
